import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {

	let obj = {
		headData: [{
				title: '报告编号',
				prop: 'reportNo',
				width: '120',
				align: "left",
				custom: true,
				issort: false
			}, {
				title: '公司名称',
				prop: 'companyName',
				width: '120',
				align: "left",
				issort: false
			}, {
				title: '生成时间',
				prop: 'generateTime',
				width: '120',
				align: "left",
				issort: false
			}, {
				title: '生成结果',
				prop: 'generateResult',
				width: '80',
				custom: true,
				issort: false
			}, {
				title: '检测期间',
				prop: 'detectionTime',
				width: '120',
				align: "left",
				issort: false
			}, {
				title: '最近更新时间',
				prop: 'updateTime',
				width: '120',
				align: "left",
				issort: false
			}, {
				title: '操作人',
				prop: 'createBy',
				width: '80',
				issort: false
			}, {
				title: '操作',
				prop: 'cz',
				fixed: 'right',
				custom: true,
				width: '160'
			}

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 3,
			paginationkey: 0
		},
		headDatabottom: [{
			title: '纳税人名称',
			prop: 'nsrmc',
			width: '120',
			align: "left",
			issort: true
		}, {
			title: '纳税人识别号',
			prop: 'companyNo',
			width: '120',
			align: "left",
			issort: true
		}, ]
	}
	return obj
}